/* eslint-disable */

/**
 * Convert answer object to points structure for progress bar
 */
function convertAnswersToPoints(answers) {
	return {
		0: { level: "", label: answers['0_pt'] || "" },
		10: { level: "1pt", label: answers['1_point'] || "" },
		30: { level: "3pt", label: answers['3_point'] || "" },
		50: { level: "5pt", label: answers['5_point'] || "" },
		70: { level: "7pt", label: answers['7_point'] || "" },
		100: { level: "10pt", label: answers['10_point'] || "" },
	};
}

const SNAP_POINTS = [0, 10, 30, 50, 70, 100];

export function initAssessmentQuestion() {
	const progressList = document.querySelectorAll(".progress");
	if (!progressList.length) return;

	progressList.forEach((pr) => {
		const containers = pr.querySelectorAll(".progress-container");

		// Get answers from data attribute
		const answersData = pr.dataset.answers;
		if (!answersData) {
			console.warn('No answers data found for progress element');
			return;
		}

		let answers;
		try {
			answers = JSON.parse(answersData);
		} catch (error) {
			console.error('Failed to parse answers data:', error);
			return;
		}

		const question = {
			points: convertAnswersToPoints(answers)
		};

		if (!question) return;

		containers.forEach((container) => {
			const fill = container.querySelector(".progress-fill");
			const pt = container.querySelector(".progress-text");
			const thumb = container.querySelector(".thumb");
			const label = pr.querySelector(".progress-label");

			let isDragging = false;

			const snapPercentage = (value) => {
				let closest = SNAP_POINTS[0];
				let minDiff = Math.abs(value - closest);

				for (const point of SNAP_POINTS) {
					const diff = Math.abs(value - point);
					if (diff < minDiff) {
						minDiff = diff;
						closest = point;
					}
				}
				return closest;
			};

			const updateProgress = (clientX) => {
				if (!isDragging) return;

				const rect = container.getBoundingClientRect();
				const offsetX = clientX - rect.left;
				const width = rect.width;

				const clampedX = Math.max(0, Math.min(offsetX, width));
				let percentage = (clampedX / width) * 100;

				percentage = snapPercentage(percentage);

				if (fill) fill.style.width = `${percentage}%`;

				const snapData = question.points[percentage] || {
					level: "",
					label: "",
				};

				if (pt) pt.textContent = snapData.level;
				if (label) label.textContent = snapData.label;

				// Update hidden input value with answer text instead of percentage
				const input = pr.querySelector('.progress-input');
				if (input) {
					input.value = snapData.label || '';
				}
			};

			const startDrag = (e) => {
				e.preventDefault();
				isDragging = true;
				const clientX = e.clientX || (e.touches && e.touches[0].clientX);
				updateProgress(clientX);
			};

			const drag = (e) => {
				if (!isDragging) return;
				const clientX = e.clientX || (e.touches && e.touches[0].clientX);
				updateProgress(clientX);
			};

			const stopDrag = () => {
				isDragging = false;
			};

			if (thumb) {
				thumb.addEventListener("mousedown", startDrag);
			}

			container.addEventListener("mousedown", startDrag);

			container.addEventListener("click", (e) => {
				if (isDragging) {
					e.preventDefault();
					e.stopPropagation();
				} else {
					updateProgress(e.clientX);
				}
			});

			// Mouse
			document.addEventListener("mousemove", drag);
			document.addEventListener("mouseup", stopDrag);

			// Touch
			container.addEventListener("touchstart", startDrag, { passive: false });
			document.addEventListener("touchmove", drag, { passive: false });
			document.addEventListener("touchend", stopDrag);
		});
	});
}
